import React from 'react';
import IssuesContent from './IssuesContent';
import RequestContent from './RequestContent';
import ApprovalsContent from './ApprovalsContent';
import CheckinsContent from './CheckinsContent';
import WikiContent from './WikiContent';
import ReportsContent from './ReportsContent';
import { withRouter } from 'react-router-dom';
const ManageContent = (props) => {
  const { apphome, pageViewType, hideCustomizeButtons, isPersonalApphome } =
    props;
  return (
    <div style={{ paddingTop: '24px', minHeight: '220px' }}>
      {pageViewType === 'issues' && (
        <IssuesContent
          isPersonalApphome={isPersonalApphome}
          hideCustomizeButtons={hideCustomizeButtons}
          apphome={apphome}
        />
      )}
      {pageViewType === 'requests' && (
        <RequestContent
          isPersonalApphome={isPersonalApphome}
          hideCustomizeButtons={hideCustomizeButtons}
          apphome={apphome}
        />
      )}
      {pageViewType === 'approvals' && (
        <ApprovalsContent
          hideCustomizeButtons={hideCustomizeButtons}
          apphome={apphome}
        />
      )}

      {pageViewType === 'checkins' && (
        <CheckinsContent
          hideCustomizeButtons={hideCustomizeButtons}
          apphome={apphome}
        />
      )}

      {pageViewType === 'wiki' && <div></div>}

      {pageViewType === 'reports' && (
        <ReportsContent
          hideCustomizeButtons={hideCustomizeButtons}
          apphome={apphome}
        />
      )}
    </div>
  );
};

export default withRouter(ManageContent);
